import { useRef, useState } from "react";
import { rawCountries, RawCountry } from "../../../../constants/phoneCode";

export const usePhoneInput = (defaultCountryCode: string) => {
  const defaultIndex = rawCountries.findIndex(c => c[2] === defaultCountryCode);

  const [country, setCountry] = useState<RawCountry>(
    rawCountries[defaultIndex]
);

  const [displayValue, setDisplayValue] = useState("");
  const [actualPhoneValue, setActualPhoneValue] = useState("");
  const existingPhoneNumber = useRef<string | null>(
    localStorage.getItem("phone_number")
  );

  const handleSelectCountry = (value: any) => {
    existingPhoneNumber.current = "";
    setCountry(value);
    localStorage.setItem("country", value[2]);
    setDisplayValue(prev => prev.replace(country[3], value[3]));
  };

  const handleOnChange = (value: string) => {
    existingPhoneNumber.current = "";
    const countryCode = country[3];
    let phone = value.replace(countryCode, "");
    const zeros = phone.match(/^0+/);
    phone = phone.replace(/^0+/, "");

    setActualPhoneValue(phone);
    setDisplayValue(`${countryCode}${zeros?.[0] ?? ""}${phone}`);
  };

  return {
    country,
    displayValue,
    actualPhoneValue,
    existingPhoneNumber,
    handleOnChange,
    handleSelectCountry,
  };
};
